import styled from '@emotion/styled';
import { Stack, Text, tokens, Button } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useAddToDemoSite } from '@hotjar/webapp/domains/activation/product-tour/useAddToDemoSite';
import DemoImg from './assets/img-demo.png';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${tokens.color.ui_background};
  border: 1px solid ${tokens.color.ui_border};
  border-radius: ${tokens.spacer.x1};
`;

export const CardBottom = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${tokens.spacer.x2};
`;

export const CardTop = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 200px;
  background-color: ${tokens.color.ember_100};
  border-bottom: 1px solid ${tokens.color.ui_border};
  background-image: url(${DemoImg});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const ProductDemoCard = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { isLoading: isAddToDemoSiteLoading, addToDemoSite } = useAddToDemoSite();
  const { click } = useTrack();

  const handleOnClick = async () => {
    click('CTA', 'Product-tour section', {});
    addToDemoSite();
  };

  return (
    <Stack direction="column" spacing="x2">
      <Text as="h3" textType="header5">
        {t(`activation:space-overview.product-tour.demo-card.title`)}
      </Text>
      <Wrapper>
        <CardTop />
        <CardBottom>
          <Text css={{ marginBottom: tokens.spacer.x2 }}>
            {t(`activation:space-overview.product-tour.demo-card.description`)}
          </Text>
          <div>
            <Button
              isLoading={isAddToDemoSiteLoading}
              loadingText={t(`activation:space-overview.product-tour.loading-demo-site`)}
              kind="secondary"
              icon="play"
              onClick={handleOnClick}
            >
              {t(`activation:space-overview.product-tour.demo-card.cta`)}
            </Button>
          </div>
        </CardBottom>
      </Wrapper>
    </Stack>
  );
};
